module.exports = __webpack_public_path__ + "static/media/delete.3782eda6.svg";